import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImpersonationBroadcastService implements OnDestroy {
  private readonly channelName = 'impersonation-state';
  private readonly storageKey = 'impersonation-broadcast-fallback';
  private readonly changedSubject = new Subject<void>();

  readonly changed$ = this.changedSubject.asObservable();

  private readonly channel: BroadcastChannel | null =
    typeof window !== 'undefined' && 'BroadcastChannel' in window ? new BroadcastChannel(this.channelName) : null;

  private readonly storageHandler = (event: StorageEvent): void => {
    if (event.key === this.storageKey) {
      this.changedSubject.next();
    }
  };

  constructor() {
    if (this.channel) {
      this.channel.onmessage = (event: MessageEvent<{ type?: string }>) => {
        if (event.data?.type === 'changed') {
          this.changedSubject.next();
        }
      };
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('storage', this.storageHandler);
    }
  }

  notifyChanged(): void {
    this.channel?.postMessage({ type: 'changed', changedAt: Date.now() });

    if (typeof window !== 'undefined') {
      localStorage.setItem(this.storageKey, String(Date.now()));
    }
  }

  ngOnDestroy(): void {
    this.channel?.close();

    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', this.storageHandler);
    }

    this.changedSubject.complete();
  }
}